// Must be the first import: it runs initializeApp() so the default Firebase
// app exists before getFirestore() is called below. This keeps the public
// site working even when no admin page has loaded yet.
import "./firebase-config.mjs";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getFirestore,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { HERO_SLIDES } from "../Components/brand";

// Uses the default Firebase app that ./firebase-config.mjs initialises.
export const db = getFirestore();

/* -------------------------------------------------------------------------- */
/*  LANDING PAGE CONTENT  (Firestore document: site/landing)                  */
/*  The public landing page reads this same document, so Save = live.         */
/*  If the read fails, the landing page falls back to DEFAULT_LANDING.        */
/* -------------------------------------------------------------------------- */

// What the site shows today, so the manager opens pre-filled the first time
// and the public page always has something to show.
export const DEFAULT_LANDING = {
  hero: {
    title: "Clean water and solar power for your land.",
    text: "MajiMaji drills boreholes and installs solar systems for homes, farms and businesses across Kenya.",
    slides: HERO_SLIDES.map(({ src, alt }) => ({ src, alt })),
  },
  gallery: HERO_SLIDES.map(({ src, alt }) => ({ src, alt })),
  testimonials: [
    {
      quote:
        "The team surveyed the land, told us honestly where to drill, and we had water running within the week we were promised.",
      name: "Farm owner",
      place: "Thika",
    },
    {
      quote:
        "Our solar pump has taken fuel off the monthly bill completely. The installation was tidy and they explained every part of it.",
      name: "Horticulture farmer",
      place: "Kiambu County",
    },
    {
      quote:
        "Quote, drilling, handover, all clear and on time. When we had a question afterwards, they picked up the phone.",
      name: "Homeowner",
      place: "Thika",
    },
  ],
  contact: {
    phone: "+254 7XX XXX XXX",
    email: "info@example.com",
    hours: "Mon to Sat, 8:00 am to 5:00 pm",
    place: "Thika, Kenya",
    lat: -1.0388,
    lng: 37.0834,
  },
};

const landingRef = () => doc(db, "site", "landing");

export async function loadLanding() {
  const snap = await getDoc(landingRef());
  if (!snap.exists()) return { data: DEFAULT_LANDING, exists: false, updatedAt: null };
  const { updatedAt, updatedBy, ...data } = snap.data();
  return {
    data: { ...DEFAULT_LANDING, ...data },
    exists: true,
    updatedAt: updatedAt?.toDate?.() ?? null,
  };
}

export async function saveLanding(data, by) {
  await setDoc(landingRef(), {
    hero: data.hero,
    gallery: data.gallery,
    testimonials: data.testimonials,
    contact: data.contact,
    updatedAt: serverTimestamp(),
    updatedBy: by || "",
  });
}

/* -------------------------------------------------------------------------- */
/*  ACTIVITY LOG  (Firestore collection: activity)                            */
/*  Never lets a logging failure break the action that triggered it.          */
/* -------------------------------------------------------------------------- */

export async function logActivity(text, by) {
  try {
    await addDoc(collection(db, "activity"), {
      text,
      by: by || "",
      createdAt: serverTimestamp(),
    });
  } catch {
    /* ignore */
  }
}